import { render, staticRenderFns } from "./ModalKasKecilUploadBuktiConfirm.vue?vue&type=template&id=f23a7778&"
import script from "./ModalKasKecilUploadBuktiConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilUploadBuktiConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports